import React, { useEffect, useState } from 'react';

import * as api from '../../../api';
import * as logger from '../../../logger';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface PaymentInfoContext {
  data: api.Payment.PaymentInfo | null;
  isLoading: boolean;
  errored: boolean;
  setData: (data: api.Payment.PaymentInfo) => void;
}

const defaultContext = {
  data: null,
  isLoading: false,
  errored: false,
  setData: () => {},
};

export const PaymentContext =
  React.createContext<PaymentInfoContext>(defaultContext);

interface Props
  extends React.PropsWithChildren<
    RouteComponentProps<{
      authenticationCode: string;
    }>
  > {
  selectedFormSetId: string;
}

const PaymentInfoProvider: React.FC<Props> = ({
  children,
  match,
  selectedFormSetId,
}) => {
  const [data, setData] = useState<PaymentInfoContext['data']>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errored, setErrored] = useState(false);
  const authenticationCode = match.params.authenticationCode;

  useEffect(() => {
    async function fetchPaymentInfo() {
      try {
        setIsLoading(true);
        const retrieved = await api.client.Payment.fetchEncounterPaymentInfo(
          authenticationCode,
          selectedFormSetId,
        );
        setData(retrieved);
      } catch (err) {
        logger.error(err);
        setErrored(false);
      } finally {
        setIsLoading(false);
      }
    }

    fetchPaymentInfo();
  }, [
    setErrored,
    setData,
    setIsLoading,
    authenticationCode,
    selectedFormSetId,
  ]);

  return (
    <PaymentContext.Provider
      value={{
        data,
        isLoading,
        errored,
        setData,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export default withRouter(PaymentInfoProvider);
